import api from './api';

// Get running titles
export const getRunningTitles = async (params = {}) => {
    try {
        const response = await api.get('/articles/running-titles', { params });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Submit an article
export const submitArticle = async (articleData) => {
    try {
        // Determine if we're sending FormData (for file uploads) or JSON
        const isFormData = articleData instanceof FormData;

        const config = {};
        if (isFormData) {
            // Let axios set the content-type automatically for FormData
            // This ensures proper multipart/form-data boundaries
            config.headers = {
                'Content-Type': 'multipart/form-data',
            };
        }

        const response = await api.post('/articles', articleData, config);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Submit a custom article (Graduate/Post Graduate/Researcher)
export const submitCustomArticle = async (articleData) => {
    try {
        // Determine if we're sending FormData (for file uploads) or JSON
        const isFormData = articleData instanceof FormData;

        const config = {};
        if (isFormData) {
            config.headers = {
                'Content-Type': 'multipart/form-data',
            };
        }

        const response = await api.post('/articles/custom-submission', articleData, config);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Get my submissions
export const getMySubmissions = async () => {
    try {
        const response = await api.get('/articles/my-submissions/running-titles');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Upload a file
export const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
        const response = await api.post('/files/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// Get public running titles that have declared results (for Home page - no deadline filter)
export const getPublicRunningTitles = async () => {
    try {
        const response = await api.get('/running-titles');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Get winners for a running title (Public API)
export const getWinners = async (runningTitleId) => {
    try {
        const response = await api.get(`/running-titles/${runningTitleId}/winners`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// Get my submitted abstracts (for Journal)
export const getMyAbstracts = async () => {
    try {
        const response = await api.get('/journal');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Submit an abstract (for Journal)
export const submitAbstract = async (abstractData) => {
    try {
        // Determine if we're sending FormData (for file uploads) or JSON
        const isFormData = abstractData instanceof FormData;

        const config = {};
        if (isFormData) {
            config.headers = {
                'Content-Type': 'multipart/form-data',
            };
        }

        const response = await api.post('/journal/abstract', abstractData, config);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Update an abstract (for Journal)
export const updateAbstract = async (submissionId, abstractData) => {
    try {
        // Determine if we're sending FormData (for file uploads) or JSON
        const isFormData = abstractData instanceof FormData;

        const config = {};
        if (isFormData) {
            config.headers = {
                'Content-Type': 'multipart/form-data',
            };
        }

        const response = await api.put(`/journal/${submissionId}/abstract`, abstractData, config);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Delete an abstract (for Journal)
export const deleteAbstract = async (submissionId) => {
    try {
        const response = await api.delete(`/journal/${submissionId}/abstract`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Razorpay Payment Integration
export const createPreSubmissionOrder = async (runningTitleId) => {
    try {
        const response = await api.post('/payment/create-order-pre-submission', { running_title_id: runningTitleId });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const verifyPayment = async (paymentData) => {
    try {
        const response = await api.post('/payment/verify', paymentData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const getMyPayments = async () => {
    try {
        const response = await api.get('/user-payments');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// Get YI article global price and enabled status
export const getYIArticlePrice = async () => {
    try {
        const response = await api.get('/payment/yi-article-price');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Resubmit a version (after modification request)
export const resubmitVersion = async (submissionId, data) => {
    try {
        const isFormData = data instanceof FormData;
        const config = {};
        if (isFormData) {
            config.headers = {
                'Content-Type': 'multipart/form-data',
            };
        }
        const response = await api.post(`/journal/${submissionId}/version`, data, config);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const syncPaymentStatus = async (orderId) => {
    try {
        const response = await api.get(`/payment/sync-status/${orderId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
